<template>
  <v-dialog v-model="dialog" max-width="1000px" scrollable>
    <template v-slot:activator="{ on }">
      <v-list-item v-on="on">
        <v-list-item-title>Editar</v-list-item-title>
      </v-list-item>
    </template>
    <v-card v-if="dialog">
      <v-card-title>
        <span class="title-preview mb-3">Editando o número de WhatsApp - {{ formattedNumber }}</span>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="6">
            <mf-text-input v-model="name" label="Nome" outlined hide-details />
          </v-col>
          <v-col cols="6">
            <mf-tooltip bottom max-width="300px">
              <template v-slot:activator="{ on }">
                <v-checkbox
                  v-if="isWhatsappPageModuleActive"
                  v-model="publicInformationActive"
                  hide-details
                  label="Exibir na página de listagem de WhatsApps"
                  v-on="on"
                />
              </template>
              <span>Marque para exibir o número na página de listagem de WhatsApps no seu hotsite.</span>
            </mf-tooltip>
          </v-col>
        </v-row>
        <div v-if="showPublicInformation">
          <v-divider class="my-4" />
          <v-row>
            <v-col cols="2">
              <mf-upload-image v-model="publicImage" dense file-name="WhatsApp-number" />
            </v-col>
            <v-col cols="10">
              <v-row>
                <v-col cols="4">
                  <mf-tooltip bottom max-width="300px">
                    <template v-slot:activator="{ on }">
                      <mf-text-input v-model="publicName" label="Nome público" outlined hide-details v-on="on" />
                    </template>
                    <span
                      >Insira o nome que será exibido no seu hotsite para o número de WhatsApp, como por exemplo o nome da loja correspondente ao número.</span
                    >
                  </mf-tooltip>
                </v-col>
                <v-col cols="8">
                  <mf-tooltip bottom max-width="300px">
                    <template v-slot:activator="{ on }">
                      <mf-text-input v-model="publicDescription" label="Descrição pública" outlined hide-details v-on="on" />
                    </template>
                    <span
                      >Insira a descrição que será exibida no seu hotsite para o número de WhatsApp, como por exemplo o endereço da loja correspondente ao
                      número.</span
                    >
                  </mf-tooltip>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <mf-tooltip bottom max-width="300px">
                    <template v-slot:activator="{ on }">
                      <mf-text-input v-model="publicMessage" label="Mensagem pública" outlined rows="3" hide-details v-on="on" />
                    </template>
                    <span>Insira a mensagem que será inserida no início da conversa nos links para o WhatsApp no seu hotsite.</span>
                  </mf-tooltip>
                </v-col>
                <v-col cols="6">
                  <v-select
                    v-model="publicHotsiteSlots"
                    label="Hotsites onde o número será exibido"
                    multiple
                    outlined
                    hide-details
                    :items="hotsiteSlotsUrls"
                    item-text="label"
                    item-value="value"
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </div>
      </v-card-text>
      <v-card-actions>
        <mf-action-buttons
          :primary-button="{
            text: 'Salvar',
            action: save,
            isVisible: true,
            isLoading: loading,
          }"
          :extra-button="{
            text: 'Cancelar',
            action: cancel,
            isVisible: true,
            isDisabled: loading,
          }"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { phoneNumberFormat } from '@/helpers/phoneNumberFormat.js'
import { MUTATION_UPDATE_NUMBER_PUBLIC_INFORMATION } from '@/modules/campanhas/whatsapp/graphql'

export default {
  name: 'EditConfigNumberInformation',
  props: {
    number: {
      type: Object,
      required: true,
    },
    hotsiteSlots: {
      type: Array,
      required: true,
    },
  },
  data: () => ({
    dialog: false,
    loading: false,
    name: '',
    publicInformationActive: false,
    publicName: '',
    publicDescription: '',
    publicMessage: '',
    publicImage: null,
    publicHotsiteSlots: [],
  }),
  computed: {
    isWhatsappPageModuleActive() {
      return this.$getAllowedModules()['whatsapp_page']
    },
    showPublicInformation() {
      return this.isWhatsappPageModuleActive && this.publicInformationActive
    },
    hotsiteSlotsUrls() {
      return this.hotsiteSlots
        .map((hotsiteSlot) => {
          return hotsiteSlot.urls.map((url) => {
            return {
              label: url,
              value: hotsiteSlot._id,
            }
          })
        })
        .flat()
    },
    formattedNumber() {
      return this.number ? phoneNumberFormat(this.number.number) : ''
    },
  },
  watch: {
    dialog(newVal) {
      if (newVal && this.number) {
        this.name = this.number.name || ''
        this.publicInformationActive = this.number.public_information?.active || false
        this.publicName = this.number.public_information?.name || ''
        this.publicDescription = this.number.public_information?.description || ''
        this.publicMessage = this.number.public_information?.message || ''
        this.publicImage = this.number.public_information?.image || null
        this.publicHotsiteSlots = this.number.public_information?.hotsite_slots?.map((hotsiteSlot) => hotsiteSlot._id) || []
      }
    },
  },
  methods: {
    async save() {
      this.loading = true
      // Stubbed save function
      try {
        const variables = {
          data: {
            _id: this.number._id,
            name: this.name,
          },
        }
        if (this.showPublicInformation) {
          variables.data.public_information = {
            active: this.publicInformationActive,
            name: this.publicName,
            description: this.publicDescription,
            message: this.publicMessage,
            image: this.publicImage,
            hotsite_slot_ids: this.publicHotsiteSlots,
          }
        }
        await this.$apollo.mutate({ mutation: MUTATION_UPDATE_NUMBER_PUBLIC_INFORMATION, variables })
        this.$snackbar({ message: 'Informações públicas do número de WhatsApp atualizadas com sucesso.', snackbarColor: 'success' })
        this.$emit('update')
      } catch (error) {
        console.error(error)
        this.$snackbar({ message: 'Erro ao atualizar informações públicas do número de WhatsApp.', snackbarColor: 'error' })
      } finally {
        this.loading = false
        this.dialog = false
      }
    },
    cancel() {
      this.dialog = false
    },
  },
}
</script>
